import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DxButtonModule } from 'devextreme-angular';
import { LanguageService } from '../../../services/language.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cancelbutton',
  templateUrl: './cancelbutton.component.html',
  styleUrl: './cancelbutton.component.scss',
  standalone: true,
  imports: [DxButtonModule],
})
export class CancelbuttonComponent {

  constructor(
    public langService: LanguageService,
    private translate: TranslateService) {
  }
  @Input() text: string = 'Cancel';
  @Input() type: 'default' | 'success' | 'danger' | 'normal' = 'default';

  @Output() clicked = new EventEmitter<void>();

  get translatedText(): string {
    return this.translate.instant(this.text);
  }

  closeModal() {
    this.clicked.emit();
  }
}
